import { render } from "./MobileMain.vue?vue&type=template&id=588852c9"
import script from "./MobileMain.vue?vue&type=script&lang=js"
export * from "./MobileMain.vue?vue&type=script&lang=js"

import "./MobileMain.vue?vue&type=style&index=0&id=588852c9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__